import(/* webpackMode: "eager", webpackExports: ["LegalsContent"] */ "/vercel/path0/app/[locale]/legals/[slug]/_components/LegalsContent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguagesProvider"] */ "/vercel/path0/components/globals/LanguagesProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientPageView"] */ "/vercel/path0/providers/GTMTrackingProvider/ClientPageView.tsx");
